module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ZOOLOGY-411c8f4101a831e4d8079740668ff076.png";